module.exports = {
      id: "xijian-logo-usage",
      viewBox: "0 0 86 32",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#xijian-logo-usage",
      toString: function () {
        return this.url;
      }
    }